// pages/AboutPage.js
import React, { useState, useEffect } from "react";
import "./pages.css"; // Import the AboutUs component
import { imgURL } from "../components/Config";
import { getAllDataWithFlag } from "../services/CommonService";
import Carousel from "../components/Carousel/imageCarosel/ImageCarousel";

function AboutPage() {
  const [aboutData, setAboutData] = useState([]);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Fetch data from your API
    const fetchAboutData = async () => {
      try {
        // Replace with your actual API endpoint
        setLoading(true);
        const response = await getAllDataWithFlag(2);
        const responseData = response?.data?.diversionary_trajectory;
        let desc = (
          <p
            className="aboutus about-one__text"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
            dangerouslySetInnerHTML={{ __html: responseData[0]?.description }}
          />
        );
        setAboutData({ id: responseData[0]?.id, desc: desc });
        const images = responseData[0]?.images.map((m) => {
          return `${imgURL}diversionary_image/${m.diversionary_image}`;
        });
        setSlides(images);
      } catch (error) {
        setAboutData({
          ...aboutData,
          loading: false,
          error: "Failed to load about us details",
        });
        console.error("Error fetching about data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <div className="text-body">
      {/* Banner Image */}
      <div className="w-100 overflow-hidden">
        {" "}
        {/* Approximate height */}
        {!loading && <Carousel
            slides={slides || ['/assets/images/bannerDefault.jpg']}
            showOverlay={false}
            overlayContent={null}
            showIndicators={false}
            height="350px"
            width="100%"
            zoom={false}
            hideNav={true}
          />}
      </div>

      {/* About Us Content */}
      <div className="container py-5">
        {" "}
        {/* Using py-5 for vertical padding */}
        <h1 className="border-bottom border-secondary pb-3 mb-4">About Us</h1>
        <section className="mb-5">
          {" "}
          {/* Using mb-5 for margin-bottom */}
          {aboutData?.desc}
        </section>
          <div className="text-center">
            <h3 className="text-warning fs-6">ACWADAM Interventions</h3>{" "}
            {/* Using fs-6 for smaller heading */}
            {!loading && <Carousel
            slides={slides}
            showOverlay={false}
            overlayContent={null}
            showIndicators={false}
            zoom= {false}
            // height="300px"
            // width="100%"
          />}
          </div>
      </div>
    </div>
  );
}

export default AboutPage;
